module.exports = __webpack_public_path__ + "static/media/presentation.74291c41.svg";